/* eslint-disable */
// src/layouts/localDeposito/data/localDepositoTableData.js

import React from "react";
import MDBox from "components/MDBox";
import IconButton from "@mui/material/IconButton";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";

export default function localDepositoTableData({ machines, onDiscard, onMove }) {
  return {
    columns: [
      { Header: "Tipo", accessor: "MachineType", align: "left" },
      { Header: "Máquina", accessor: "Machine", align: "left" },
      { Header: "", accessor: "Actions", align: "left" },
    ],

    rows: (machines || []).map((m) => ({
      MachineType: m.MachineType?.Type || "Sin tipo",
      Machine: `${m.SerialNumber || "Sin serie"} · ${m.Name || "Sin nombre"}`,
      Actions: (
        <MDBox display="flex" justifyContent="flex-start" gap={1}>
          <IconButton
            name="moveFromDeposito"
            aria-label="Mover a otro depósito"
            color="primary"
            onClick={() => onMove && onMove(m)}
          >
            <SwapHorizIcon />
          </IconButton>
          <IconButton
            name="discardFromDeposito"
            aria-label="Dar de baja máquina"
            color="error"
            onClick={() => onDiscard && onDiscard(m)}
          >
            <DeleteForeverIcon />
          </IconButton>
        </MDBox>
      ),
    })),
  };
}
